<template>
  <div>
    <ht-action-panel :on-search="getList" :on-clear="onClear">
      <template slot="left">
        <el-select v-model="listQuery.constructionEquipmentName" placeholder="设备名称">
          <el-option v-for="(item,index) in EquipmentTypesEnum" :key="index" :label="item.name" :value="item.value" />
        </el-select>
        <el-input v-model="listQuery.constructionEquipmentCode" placeholder="产权编号" />
        <el-input v-model="listQuery.constructionEquipmentSpecModel" placeholder="规格型号" />
      </template>
      <template slot="right">
        <el-button type="success" icon="el-icon-plus" :disabled="selectedEquipments.length < 1" @click="handleAddLeaseEquipments">确认</el-button>
      </template>
    </ht-action-panel>
    <ht-table ref="list" v-loading="isLoading" :data="list" :row-key="getRowKey" @selection-change="onSelectionChange">
      <ht-table-column type="selection" width="55" reserve-selection :selectable="isSelectable" />
      <ht-table-column label="序号" type="index" fixed="left" />
      <ht-table-column
        v-for="item in WarehouseEquipmentStockOutboundListTitle"
        :key="item.otherProp"
        :label="item.label"
        :prop="item.otherProp"
        :min-width="item.width || 100"
        :fixed="item.fixed"
      >
        <template v-slot="{row}">
          <span v-if="item.label === '库存数'">{{ row[item.otherProp] }}</span>
          <span v-else>{{ row[item.otherProp] || '-' }}</span>
        </template>
      </ht-table-column>
      <ht-table-column-operation :width="100">
        <template v-slot="{row}">
          <el-button :disabled="row.isAdded" type="text" icon="el-icon-plus" @click="handleAddLeaseEquipment(row)">添加</el-button>
        </template>
      </ht-table-column-operation>
    </ht-table>

  </div>
</template>

<script>
import { WarehouseEquipmentStockOutboundListTitle } from '@/views/constructionEquipmentMgr/tableTitle'
import { getStocks } from '@/api/constructionEquipmentMgr/stockMgr'
import { EquipmentTypesEnum } from '@/views/constructionEquipmentMgr/enum'

export default {
  name: 'WarehouseOutboundAddEquipmentList',
  props: {
    alreadyAddList: { type: Array, default: () => [] },
    warehouseId: { type: [String, Number], default: null }
  },
  data() {
    return {
      EquipmentTypesEnum,
      WarehouseEquipmentStockOutboundListTitle,
      selectedEquipments: [],
      selection: [],
      isLoading: false,
      list: [],
      listQuery: {
        constructionEquipmentName: undefined,
        constructionEquipmentCode: undefined,
        constructionEquipmentSpecModel: undefined
      }
    }
  },
  methods: {
    isSelectable(row) {
      if (row) {
        return !row.isAdded
      }
    },
    onClear() {
      Object.keys(this.listQuery).forEach(key => {
        this.listQuery[key] = undefined
      })
      this.getList()
    },
    getRowKey(row) {
      if (row) {
        return row.id
      }
    },
    getList() {
      this.isLoading = true
      this.listQuery.warehouseId = this.warehouseId
      getStocks(this.listQuery).then(resp => {
        resp.forEach(item => {
          const index = this.alreadyAddList.findIndex(addItem => addItem.constructionEquipmentId === item.constructionEquipmentId)
          item.isAdded = index !== -1
          item.outboundQuantity = 1
        })
        this.list = resp
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
      this.isLoading = true
    },
    onSelectionChange(val) {
      this.selectedEquipments = val
    },
    handleAddLeaseEquipments() {
      this.$emit('on-add-equipments', this.selectedEquipments)
    },
    handleAddLeaseEquipment(row) {
      this.$emit('on-add-equipments', [row])
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-container{
  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
